import axiosInstance from '@/utils/axiosInstance';

export default async function getClient() {
  return (await axiosInstance.get<Client>('/client')).data;
}

export type Client = {
  id: number;
  number: string;
  status:
    | 'UNKNOWN'
    | 'REGISTERED'
    | 'IDENTIFIED'
    | 'DELETED'
    | 'VALIDATED'
    | 'ACTIVE'
    | 'NOT_IDENTIFIED';
  declaredAddress: {
    fullAddress: string;
    postalCode: string;
    location1: string;
  };
  identityDocumentDateOfExpiry: string;
  actualAddress: {
    fullAddress: string;
    postalCode: string;
    location1: string;
  };
  mobilePhoneVerified: boolean;
  firstName: string;
  lastName: string;
  fullName: string;
  personalId: string;
  identificationNumber: string;
  identityDocumentId: string;
  isDocumentIdentified: boolean;
  dateOfBirth: string;
  age: number;
  identifiedBy:
    | 'BANK'
    | 'MANUAL'
    | 'ID_SERVICE'
    | 'BROKER'
    | 'EMAIL'
    | 'IMMEDIATE_TRANSFER'
    | 'FINTONIC'
    | 'PRESTALO'
    | 'NOT_IDENTIFIED';
  registeredBy:
    | 'WEB'
    | 'OFFLINE'
    | 'BROKER'
    | 'CALL_CENTER'
    | 'LEAD_GENERATOR'
    | 'WEB_OTHER_PRODUCT';
  blocked: boolean;
  identified: boolean;
  bankAccount: string;
  openPrincipalAmount: number;
  homePhone: string;
  validationResolutionDetail:
    | 'PERSONAL_ID_MISSING'
    | 'EXPIRED_IDENTITY_DOCUMENT'
    | 'ERROR'
    | 'CHECK_PAYSLIP'; // NOTE: This is not the full enum, instead only the values currently used on FE side
  productNumber: number; // TODO: change to specific product number types
  additionalAmount: boolean;
  creditLimit: number;
  totalCreditLimit: number;
  hasOpenLoan: boolean;
  _embedded: {
    mobilePhone: {
      mobilePhone: string;
    };
    email: {
      email: string;
    };
  };
};
